import { render } from "./MainInsuranceCompanies.vue?vue&type=template&id=4b12d7a2&scoped=true"
import script from "./MainInsuranceCompanies.vue?vue&type=script&lang=js"
export * from "./MainInsuranceCompanies.vue?vue&type=script&lang=js"

import "./MainInsuranceCompanies.vue?vue&type=style&index=0&id=4b12d7a2&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b12d7a2"]])

export default __exports__